import { LoadingState } from '@lcs/shared/api';
import { on } from '@ngrx/store';
import { saveExtensionGroupDetailSuccess } from 'src/app/pages/extension-group-details/state/extension-group-detail.actions';
import {
   createEagerSelectAdapter,
   createEagerSelectReducer,
   EagerSelectState,
} from '../../select/eager-select/eager-select-reducer';
import { ExtensionGroupOption } from '../models/extension-group-option';
import { extensionGroupOptionActions } from './extension-group-option.actions';

export const extensionGroupOptionFeatureKey = 'extensionGroupOptions';

export type ExtensionGroupOptionState = EagerSelectState<ExtensionGroupOption>;

const adapter = createEagerSelectAdapter<ExtensionGroupOptionState, ExtensionGroupOption>({
   featureKey: extensionGroupOptionFeatureKey,
   selectId: (extensionGroup: ExtensionGroupOption) => {
      return extensionGroup.extensionGroupId;
   },
});

export const extensionGroupOptionSelectors = adapter.getSelectors(filterExtensionGroupOption);

const initialState = adapter.getInitialState();

export const extensionGroupOptionsReducer = createEagerSelectReducer(
   adapter,
   initialState,
   extensionGroupOptionActions.search,
   extensionGroupOptionActions.searchReset,
   extensionGroupOptionActions.loadFromApi,
   extensionGroupOptionActions.loadFromApiSuccess,
   extensionGroupOptionActions.loadFromApiFailure,
   null,
   on(saveExtensionGroupDetailSuccess, (state) => {
      return {
         ...state,
         callState: LoadingState.Init,
      };
   })
);

export interface ExtensionGroupSelectOption {
   name: string | null;
}

export function filterExtensionGroupOption<T extends ExtensionGroupSelectOption>(
   types: T[],
   searchText: string | null | undefined
): T[] {
   if (types.length === 0) {
      return [];
   }
   const term = searchText && searchText.trim();
   if (term) {
      const upper = term.toUpperCase();
      return types.filter((item) => {
         return item.name ? item.name.toUpperCase().includes(upper) : false;
      });
   } else {
      return types || [];
   }
}
